import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { ContentIntro } from 'apps/components/contentIntro';
import FileFormatsTable from 'apps/home/fileFormats/fileFormatsTable';

@withNamespaces()
@inject('routerStore')
@observer
export class FileFormatsPage extends React.Component {
  render() {
    return (
      <>
        <Header />
        <ContentIntro
          title='Supported file formats.'
          hideButtonWhenSignIn
          variant='primary'
          isCentered
        />
        <FileFormatsTable marginTopBottom='6rem' />
      </>
    );
  }
}

FileFormatsPage.propTypes = {
  t: PropTypes.func,
};
